<template>
    <div>
        <h2 class="ViewHeading">Battery Overview</h2>
    <div>
        <b-card>
            <b-tabs card>
                <b-tab active>
                <template #title>
                O1 Devices
                </template>
                    show status here, option to mark as changed
                </b-tab>
            </b-tabs>

        </b-card>
    </div>
    </div>
</template>
<script>
    export default {
      data() {
      return {}
    },
    computed: {},
    components: {},
    methods:{},

    }
</script>

<style>

</style>